<div class="demo-container">
  <div class="demo-header">
    <h1>Catalogue Analysis Tree Diagram</h1>
    <p>
      Interactive tree visualization for music catalogue analysis with
      comprehensive breakdown of revenue, potential, and risk factors.
    </p>
  </div>

  <div class="demo-content">
    <mzic-catalogue-analysis-tree></mzic-catalogue-analysis-tree>
  </div>

  <div class="demo-features">
    <h3>Features</h3>
    <ul>
      <li>Interactive nodes - click to expand/collapse branches</li>
      <li>
        Color-coded impact indicators (positive, negative, critical, neutral)
      </li>
      <li>Metrics visualization (percentages, trends, priorities)</li>
      <li>
        Comprehensive catalogue breakdown including:
        <ul>
          <li>Works vs Sound Recordings analysis</li>
          <li>Revenue distribution and concentration</li>
          <li>Asset potential evaluation</li>
          <li>Recording artist impact factors</li>
          <li>Sync revenue analysis</li>
        </ul>
      </li>
      <li>Expand/Collapse all controls</li>
      <li>Responsive design</li>
    </ul>
  </div>
</div>

